
import {setStorage, getStorage, removeStorage} from '@/libs/Storage'

import { getAccessToken, setAccessToken} from "@/libs/accessToken";
import {getCityApi, getConfig, getAuthInfo} from "@/api/api";
import { decryptAES } from "@/utils";
const formData={
        phone: '',
        verifycode: '',
        amount: 100,
        name: '',
        id_card: '',
        house: 100,
        car:  200,
        fund: 300,
        social: 400,
        insurance: 500,
        business_owner: 600,
        huabei: 700,
        baitiao: 800,
        credit_card: '',
        credit_history: 1001,
        zhima:1100,
        loan_limit: 1200,
        is_ready: false
    }
const actions = {
    getCity({commit}){
        getCityApi().then(res=>{
            const { data } = res;
            commit('setCity', data)
        })
    },

    async getConfig({commit, state}){
        if(!state.appConfig){
            const { data } = await getConfig();
            commit('setConfig', data)
        }
    },

    async getAuthInfo({commit}, code){
        const { data } = await getAuthInfo({code})
        commit('crashResponse', data.crashResponse)
        commit('setChannel', data.channel)
    }
}

const mutations = {
    setAccess: (state, access) =>{
        setStorage('access', access, 'cookie',0);
        state.access = access;
    },
    setChannel: (state, channel) =>{
        setStorage('channel', channel);
        state.channel = channel;
    },

    setAccessToken: (state, data)=>{
        setAccessToken(data);
        state.accessToken = data;
    },
    setConfig:(state, data)=>{
        state.appConfig = data;
        setStorage('appConfig', data);
    },

    qualiOption: (state, data)=>{
        state.qualiOption = data;
    },



    crashResponse: (state, data) => {
        if(getStorage('crashResponse')){
            removeStorage('crashResponse')
        }
        setStorage('crashResponse', data)
        state.crashResponse = data
    },

    initFormData:(state, data) => {
        Object.keys(state.formData).forEach(key => {
            if(data[key]) state.formData[key] = data[key]
        })
      
    },
}

const state = ()=>({
    /**
     * 用户身份密钥
     */
    access: getStorage('access') ?? '',
    /**
     * 渠道信息
     */
    channel: getStorage('channel') ?? {},
    /**
     * 用户登录密钥
     */
    accessToken: getAccessToken() ?? '',

    qualiOption: {},
    // 城市列表
    cityList: [],
    // 撞库返回的数据
    crashResponse: getStorage('crashResponse') ?? {},
    /**
     * 系统配置
     */
    appConfig: getStorage('appConfig') ?? {},
    
    /**
     * 表单
     */
    formData: getStorage('formData') ?? formData,
    
})

const getters = {
    access: state => state.access,
    channel: state => state.channel,
    accessToken: state => state.accessToken,
    qualiOption: state => state.qualiOption,
    cityList: state => state.cityList,
    crashResponse: state => state.crashResponse,
    appConfig: state => state.appConfig,
    formData: state =>{
        setStorage('formData',state.formData,'local')
        return state.formData
    } 
}

export default {
    namespaced: true,
    actions, mutations, state, getters
}